

















































import Vue from 'vue'
import { mutations, portalState } from '@/state'
import LocationMarker from '@/components/Global/LocationMarker.vue'
import Loader from '@/components/Global/Loader.vue'
import { apiDeleteEntity, apiRecentlyInstalledEntities } from '@/api'

export default Vue.extend({
  name: 'RecentEntities.vue',
  components: { Loader, LocationMarker },
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    loggedInUser () { return portalState.user }
  },
  data () {
    return {
      recentEntities: [],
      loading: true,
      fetchInterval: null
    }
  },
  methods: {
    getRecentEntities () {
      apiRecentlyInstalledEntities().then((res: any) => {
        this.recentEntities = res.data.data
        this.loading = false
      }).finally(() => {
        this.gsapFadeIn()
      })
    },
    async deleteEntity (entity: any) {
      const { isConfirmed } = await this.sweetAlert(this.t({ s: 'confirmText', component: 'messages' }, [entity.name]))
      if (!isConfirmed) return

      try {
        mutations.setSnackbar()
        await apiDeleteEntity(entity.id)
        this.getRecentEntities()
        mutations.setSnackbar('success', this.t({s: 'success', component: 'Snackbar'}))
      } catch (e) {
        mutations.setSnackbar('error', e.response.data.message)
      }
    },
    recentlyActive (e: any) {
      const check = this.$moment().utc().subtract(24, 'hours')
      return e.positioned_at ? this.$moment(e.positioned_at).isAfter(check) : false
    },
    getGpsStrength (satellites: number | undefined) {
      if (!satellites) {
        return { tooltip: 'lastWaypointsWeakGps', color: 'text--secondary' }
      }
      if (satellites > 6) {
        return { tooltip: 'lastWaypointsStrongGps', color: 'success' }
      } else if (satellites > 1) {
        return { tooltip: 'lastWaypointsMediumGps', color: 'warning' }
      }
    }
  },
  mounted () {
    this.getRecentEntities()
    this.fetchInterval = setInterval(this.getRecentEntities, 300000)
  },
  beforeDestroy () {
    clearInterval(this.fetchInterval)
  }
})
